import api from './axios';

// ALERT MONITORING & HISTORY (runtime Alert incidents — not visual templates)
export const alertMonitoringApi = {
  getActive: async () => {
    const res = await api.get('/admin/alerts/active');
    return res.data;
  },

  getStats: async () => {
    const res = await api.get('/admin/alerts/stats');
    return res.data;
  },

  getHistory: async (params) => {
    const res = await api.get('/admin/alerts', { params });
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/admin/alerts/${id}`);
    return res.data;
  },

  getAnalytics: async (params) => {
    const res = await api.get('/admin/alerts/analytics', { params });
    return res.data;
  },

  resolveAlert: async (id, notes) => {
    const res = await api.post(`/admin/alerts/${id}/resolve`, { notes });
    return res.data;
  },

  /** Read-only AppAlert types for history filter dropdown */
  getAppAlertTypes: async () => {
    const res = await api.get('/admin/alerts/types');
    return res.data;
  },
};

export default alertMonitoringApi;
